"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const AddCircleOutlineRounded_1 = __importDefault(require("@mui/icons-material/AddCircleOutlineRounded"));
const react_beautiful_dnd_1 = require("react-beautiful-dnd");
const Button_1 = __importDefault(require("../../../global/Button/Button"));
const arrayFieldsDragAndDrop_1 = require("../../../../utilities/arrayFieldsDragAndDrop/arrayFieldsDragAndDrop");
const ArrayOfPrimitivesItem_1 = __importDefault(require("./ArrayOfPrimitivesItem"));
const clsx_1 = __importDefault(require("clsx"));
const ArrayField_constants_1 = require("./ArrayField.constants");
const ArrayOfPrimitives = (props) => {
    const { items, canAdd, disabled, onAddClick, idSchema, fixedItemCount } = props;
    const onDragStart = (result) => {
        // Force focus on the element so that `recordChanges` fires and sets in motion all the other data updates
        (0, arrayFieldsDragAndDrop_1.focusDragHandle)(result.draggableId, 'focus');
    };
    const onDragEnd = (result) => {
        (0, arrayFieldsDragAndDrop_1.reorderItems)(result, items);
        // Remove the temporary focus on drag handle that was needed to fire off `recordChanges`
        (0, arrayFieldsDragAndDrop_1.focusDragHandle)(result.draggableId, 'blur');
    };
    const addButton = (react_1.default.createElement(react_1.default.Fragment, null, canAdd && (react_1.default.createElement("div", { className: "hide-while-drag mt-1", "data-id": ArrayField_constants_1.ARRAY_FIELD_DATA_IDS.addItemToPrimitiveArray },
        react_1.default.createElement(Button_1.default, { isDisabled: disabled, text: "Add", onClick: onAddClick, variant: "link", className: "!p-0", icon: react_1.default.createElement(AddCircleOutlineRounded_1.default, { className: "icon" }) })))));
    if (items.length === 0) {
        return addButton;
    }
    const groupWrapperClass = (0, clsx_1.default)('primitive-array-group', {
        ['primitive-array-group--can-add']: canAdd,
        ['primitive-array-group--disabled']: disabled,
    });
    return (react_1.default.createElement("div", { className: groupWrapperClass, "data-id": ArrayField_constants_1.ARRAY_FIELD_DATA_IDS.arrayOfPrimitives },
        react_1.default.createElement(react_beautiful_dnd_1.DragDropContext, { onDragStart: onDragStart, onDragEnd: onDragEnd },
            react_1.default.createElement(react_beautiful_dnd_1.Droppable, { droppableId: `droppable-${idSchema.$id}`, isDropDisabled: disabled }, (dropProvided) => (react_1.default.createElement("div", { className: "primitive-array-group__list", ...dropProvided.droppableProps, ref: dropProvided.innerRef },
                items &&
                    items.map((element) => (react_1.default.createElement(ArrayOfPrimitivesItem_1.default, { ...element, fixedItemCount: fixedItemCount, uniqueId: element.key, key: element.key }))),
                dropProvided.placeholder)))),
        addButton));
};
exports.default = ArrayOfPrimitives;
